import { useStage } from './useStage'

export default () => useStage('phone-number-registration')
